import ModalVistaPrevia from 'components/Admin/Certificados/ModalVistaPrevia'
import { UserData } from 'components/Sidebar/Sidebar_Principal'
import { alertService } from 'components/Varios/alert_service'
import Cargando from 'components/Varios/Cargando'
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos'
import { GetDocumentVistaPrevia } from 'helpers/files'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { authenticationService } from 'services/authentication.service'
import { HistorialSolicitudesTH } from './TyperHistorialAprobaciones'
import { ObtenerAniosHistorialNotificado, ObtenerHistorialEstadoNotificado } from './FunctionsHistorialAprobaciones'
import TablaHistorialNotificadoth from './TablaHistorialNotificadoTH'
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion'
import { GetDateObjectFromDate, ObtenerFechaFromIsoFormat, ParseFechaToUsaFormat } from 'functions/DatesFunctions'
import { Row, Col, Table, Container } from "reactstrap";


type StateHistorialAprobacion = {
    aniosDisponibles: number[],
    historial: HistorialSolicitudesTH[],
    loading: boolean,
    error: boolean,
    anioSeleccionado: number

}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}

type StateModalMotivoRechazo = {
    loading: boolean,
    tabladetalle: HistorialSolicitudesTH | undefined,
}


export default function HistorialEstadoNotificado() {

    const defaultStateHistorial: StateHistorialAprobacion = {
        aniosDisponibles: [],
        historial: [],
        loading: false,
        error: false,
        anioSeleccionado: -1
    }

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {

        loading: false,
        url: ""
    }

    const defaultStateModalMotivoRechazo: StateModalMotivoRechazo = {
        loading: false,
        tabladetalle: undefined,
    }

    const [stateHistorial, setstateHistorial] = useState<StateHistorialAprobacion>(defaultStateHistorial)
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)
    const [stateModalMotivoRechazo, setstateModalMotivoRechazo] = useState<StateModalMotivoRechazo>(defaultStateModalMotivoRechazo)


    async function ObtenerInformacionAniosHistorial() {
        setstateHistorial({ ...stateHistorial, loading: true })
        const respuesta = await ObtenerAniosHistorialNotificado();
        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial de solicitudes pendientes de evidencia");
            setstateHistorial({ ...stateHistorial, loading: false, error: true })

        }
        else {
            const anioSeleccionado = respuesta.dataResponse[0]
            setstateHistorial({ ...stateHistorial, loading: false, aniosDisponibles: respuesta.dataResponse, anioSeleccionado })

        }

    }


    useEffect(() => {
        ObtenerInformacionAniosHistorial();
    }, [])





    const GetHistorialByYear = useCallback(async (anio: number) => {

        setstateHistorial({ ...stateHistorial, loading: true })
        const respuesta = await ObtenerHistorialEstadoNotificado(anio)

        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial de solicitudes pendientes de evidencia")
            setstateHistorial({ ...stateHistorial, error: true, loading: false })
        }
        else {
            setstateHistorial({ ...stateHistorial, historial: respuesta.dataResponse, loading: false, anioSeleccionado: anio })
        }
    }, [stateHistorial])


    async function ConsultarHistorial(stateHistorial: StateHistorialAprobacion) {
        setstateHistorial({ ...stateHistorial, loading: true })
        const anio = stateHistorial.anioSeleccionado
        const respuesta = await ObtenerHistorialEstadoNotificado(anio)
        if (respuesta.status !== 200) {
            alertService.error("Ha ocurrido un inconveniente al obtener el historial de solicitudes pendientes de evidencia")
            setstateHistorial({ ...stateHistorial, error: true, loading: false })
        }
        else {
            setstateHistorial({ ...stateHistorial, historial: respuesta.dataResponse, loading: false })
        }

    }

    const onClickVerDoc = useCallback(
        async (referencia: string) => {
            setstateModalVP({ ...stateModalVP, loading: true })
            const datosUsuario: UserData = authenticationService.currentUserValue;
            const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
            setstateModalVP({ ...stateModalVP, loading: false, url })
        }, [stateModalVP])

    const VerMotivoRechazo = (solicitud: HistorialSolicitudesTH) => {
        setstateModalMotivoRechazo({ tabladetalle: solicitud, loading: false, })
    }

    const contenidoModalMotivoRechazo: any = useMemo(() => {
        if (stateModalMotivoRechazo.loading) {
            return <Cargando />
        }
        else if (stateModalMotivoRechazo.tabladetalle === undefined) {
            return (
                <>
                    <br />
                    <p className='text-center'>No hay detalle de permisos / licencias</p>
                </>
            )
        }
        else if (stateModalMotivoRechazo.tabladetalle !== undefined) {
            const solicitud = stateModalMotivoRechazo.tabladetalle;
            const tabla =
                <>
                    <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                        <thead className="cabecerasDetallehistorialSolic">
                            <tr className="">
                                <th style={{ fontSize: '18px', padding: '15px', whiteSpace: 'pre-line', lineHeight: '1.6' }}> Motivo del Rechazo </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="rowHistorialSolicitudVacaciones" key={"rowDetalleHistorico " + solicitud.idpermiso}>
                                <td className="">
                                    <div style={{ fontSize: '16px', padding: '15px', whiteSpace: 'pre-line', lineHeight: '1.6' }}>
                                        {solicitud.motivo}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </>
            return tabla;
        }
    }, [stateModalMotivoRechazo])      

    useEffect(() => {
        if (stateHistorial.aniosDisponibles.length > 0) {
            ConsultarHistorial(stateHistorial);
        }
    }, [stateHistorial.aniosDisponibles])

    const tablaHistorial = useMemo(() => {
        if (stateHistorial.loading) {
            return <Cargando />
        }
        else if (stateHistorial.error) {
            return <div>No ha sido posible obtener información</div>
        }
        else if (!stateHistorial.error && (stateHistorial.aniosDisponibles.length === 0 && stateHistorial.historial.length === 0)) {
            return <div>No hay historial de solicitudes por mostrar</div>

        }
        else if (!stateHistorial.loading && stateHistorial.historial.length > 0) {
            return (
                <TablaHistorialNotificadoth
                    anioSeleccionado={stateHistorial.anioSeleccionado}
                    dataFilas={stateHistorial.historial}
                    onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}
                    onChangeAnio={(a: number) => GetHistorialByYear(a)}
                    onClickVerMotivo={async (solicitud: HistorialSolicitudesTH) => await VerMotivoRechazo(solicitud)}
                />
            )
        }
    }, [stateHistorial])



    return (
        <div className="content">
            <div className="titulo_seccion mb-5"> SOLICITUDES DE PERMISOS Y LICENCIAS PENDIENTES DE REGULARIZACIÓN </div>

            {
                tablaHistorial
            }
            <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Documento solicitud'
                urlArchivo={stateModalVP.url}
                botonCerrar={true}


            />

            <ModalConfirmacion
                show={stateModalMotivoRechazo.tabladetalle !== undefined}
                asyncAccion={false}
                asyncClose={false}
                closeAfterAccion={false}
                hideBotonCerrar={false}
                mensajeConfirmacion={""}
                nombreBotonAccion={"Cerrar"}
                onClose={() => setstateModalMotivoRechazo({ tabladetalle: undefined, loading: false, })}
                size={"xl"}
                contentModal={contenidoModalMotivoRechazo}
                tituloModal={"Motivo del rechazo de la solicitud"}
                classNameAllModal={""}
            />

        </div>
    )
}
